import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptorService, EnvironmentLabelModule, LayoutModule, ShowMessageService } from 'ahm-angular';
import { MdbCookiesManagementService } from 'mdb-angular-cookies-management';
import { MdbScrollStatusService } from 'mdb-angular-scroll-status';
import { MdbStorageManagementService } from 'mdb-angular-storage-management';
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MessageService } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './source/services/auth.service';
import { AppErrorInterceptorService } from './source/services/interceptors/error-interceptor.service';
import { SharedModule } from './source/shared/shared.module';
import { AppWrapperComponent } from './source/app-wrapper-component/app-wrapper-component';


@NgModule({
  declarations: [
    AppComponent,
    AppWrapperComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
    ToastModule,
    MdbCheckboxModule,
    EnvironmentLabelModule,
    MdbCarouselModule,
    MenubarModule,
    MenuModule,
    SharedModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppErrorInterceptorService, multi: true },
    MessageService,
    AuthService,
    ShowMessageService,
    MdbCookiesManagementService,
    MdbStorageManagementService,
    MdbScrollStatusService,
    {provide: 'env', useValue: environment}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
